import React from 'react';
import PropTypes from 'prop-types';
import { Button, Input, Dropdown } from 'react-toolbox';
import S from '../TemplateStyling.scss';

const itemOrLabor = [
  { value: 'Item', label: 'Item' },
  { value: 'Labor', label: 'Labor' },
];

function LaborMaterial({ labors_materials, onChange }) {
  const handleFieldChange = (idx, field, value) => {
    const updated = labors_materials.map((m, i) =>
      (i === idx ? { ...m, [field]: value } : m),
    );
    onChange(updated);
  };

  const addRow = () => {
    onChange([
      ...labors_materials,
      {
        itemOrLabor: '',
        qty: '',
        costToLowes: '',
        description: '',
      },
    ]);
  };

  const removeRow = (idx) => {
    onChange(labors_materials.filter((_, i) => i !== idx));
  };

  return (
    <div>
      <h6>Additional Labor/Material</h6>
      {labors_materials.map((item, idx) => (
        <div key={item.itemOrLabor || `additional-${idx}`} style={{ border: '1px solid #eee', marginBottom: 10, padding: 10 }}>
          <Dropdown label="Item / Labor" source={itemOrLabor} value={item.itemOrLabor} onChange={v => handleFieldChange(idx, 'itemOrLabor', v)} />
          <Input label="Qty" value={item.qty} onChange={v => handleFieldChange(idx, 'qty', v)} />
          <Input label="Cost to Lowes" value={item.costToLowes} onChange={v => handleFieldChange(idx, 'costToLowes', v)} />
          <Input label="Description" value={item.description} onChange={v => handleFieldChange(idx, 'description', v)} />
          <Button className={S.removeButton} label="Remove" onClick={() => removeRow(idx)} />
        </div>
      ))}
      <Button className={S.button} label="Add Item" onClick={addRow} />
    </div>
  );
}

LaborMaterial.propTypes = {
  labors_materials: PropTypes.arrayOf(
    PropTypes.shape({
      itemOrLabor: PropTypes.string,
      qty: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      costToLowes: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      description: PropTypes.string,
    }),
  ),
  onChange: PropTypes.func.isRequired,
};

export default LaborMaterial;

export function validateLaborMaterials(labors_materials) {
  const errors = {};
  labors_materials.forEach((item, idx) => {
    const numberFields = ['qty', 'costToLowes'];
    numberFields.forEach((field) => {
      const value = item[field];
      if (value === undefined || value === '') return;
      if (isNaN(Number(value))) {
        if (!errors[idx]) errors[idx] = {};
        errors[idx][field] = [`${field} must be a number.`];
        return;
      }
      if (field === 'qty' && Number(value) === 0) {
        if (!errors[idx]) errors[idx] = {};
        errors[idx][field] = [`${field} cannot be 0, starts in a unit of 1.`];
        return;
      }
      if (field === 'costToLowes' && Number(value) !== Number(Number(value).toFixed(3))) {
        if (!errors[idx]) errors[idx] = {};
        errors[idx][field] = [`${field} cannot have more than 3 decimal places.`];
      }
    });
  });
  if (Object.keys(errors).length > 0) {
    errors.laborMaterials = [
      'Please ensure all Qty and Cost fields are valid numbers.',
    ];
  }
  return errors;
}



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/components/LaborMaterial.jsx